import {AccessGroupDto, AccessPoint, AccessPointOccupants, DoorPrevTime} from '../../models/access-point/access-point';
import {CommandStatusType} from '../../models/command-response';
import {AccessPointStatusSignalR} from '../../models/notification-payload';
import {Subject} from 'rxjs';

export class LoadAccessPoints {
  static readonly type = '[Access Points] Get Access Points';

  constructor(public resetChunk: boolean = false, public loadAll: boolean = false) {
  }
}

export class GetDoorsConfiguration {
  static type = '[Access Points] Get Doors Configuration';
}

export class LoadUserAccessPoints {
  static readonly type = '[Access Points] Load User Access Points';

  constructor() {
  }
}

export class SearchAccessPoints {
  static readonly type = '[Access Points] Search Access Points';

  constructor(public searchTerm: string) {
  }
}

export class SecureAccessPoint {
  static readonly type = '[Access Points] Secure Access Point';

  constructor(public accessPointId: string, public currentState: boolean, public secureInSeconds?: number) {
  }
}

export class OpenCloseAccessPoint {
  static readonly type = '[Access Points] Open Access Point';

  constructor(public accessPointId: string, public open: boolean, public doorDefaultTimeSeconds: number = 4) {
  }
}

export class UpdateSecureRequestStatus {
  static readonly type = '[Access Points] Change Access Point Secure State';

  constructor(public accessPointId: string, public status: CommandStatusType, public secureState: boolean) {
  }
}

export class SetSelectedAccessPoint {
  static readonly type = '[Access Points] Set Selected Access Point';

  constructor(public accessPoint: AccessPoint, public occupantsPerPage: number, public accessGroupsPerPage: number) {
  }
}
export class UpdateAccessPointLocally {
  static readonly type = '[Access Points] Update Access Point locally';

  constructor(public accessPoint: AccessPoint) {
  }
}

export class SearchAccessPointsOccupants {
  static readonly type = '[Access Points] Search Access Points Occupants';

  constructor(public page: number, public searchTerm: string = '', public occupantsSubject$: Subject<AccessPointOccupants[]> = null) {
  }
}

export class SearchAccessPointsAccessGroups {
  static readonly type = '[Access Points] Search Access Points Access Groups';


  constructor(public page: number, public searchTerm: string = '', public accessGroupSubject$: Subject<AccessGroupDto[]> = null) {
  }
}


export class LoadSelectedAccessPointData {
  static readonly type = '[Access Points] Load Selected Access Point Data';

  constructor(public accessPointId: string, public resetChunk: boolean = false) {
  }
}

export class UpdateAccessPoints {
  static readonly type = '[Access Points] Update Access Point Status';

  constructor(public readonly payload: AccessPointStatusSignalR) {
  }
}
export class UpdateAccessPointDoorPreviousTimeSeconds {
  static readonly type = '[Access Points] Update Access Point fields';

  constructor(public readonly payload: DoorPrevTime) {
  }
}


